module.exports = __webpack_public_path__ + "img/header_img5.27a203a5.png";